import Footer, { FooterProps } from './Footer';

export default Footer;
export type { FooterProps };
